import { render } from "./AssistantTeacherSubmission.vue?vue&type=template&id=75b9f528&scoped=true"
import script from "./AssistantTeacherSubmission.vue?vue&type=script&lang=js"
export * from "./AssistantTeacherSubmission.vue?vue&type=script&lang=js"

import "./AssistantTeacherSubmission.vue?vue&type=style&index=0&id=75b9f528&scoped=true&lang=scss"

import exportComponent from "D:\\CTS_SURAJ\\Edu Katta\\Private\\Edukatta_Private_Managment_UI\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75b9f528"]])

export default __exports__